import { render } from "./WCInformationCollapsibleMenu.vue?vue&type=template&id=6f9ef64b&scoped=true"
import script from "./WCInformationCollapsibleMenu.vue?vue&type=script&lang=js"
export * from "./WCInformationCollapsibleMenu.vue?vue&type=script&lang=js"

import "./WCInformationCollapsibleMenu.vue?vue&type=style&index=0&id=6f9ef64b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9ef64b"]])

export default __exports__